// Card BIN to Product Code mapping
// Based on Capitalist API documentation

export const BIN_PRODUCT_MAPPING = {
  // Hong Kong BINs
  '22351403': {
    productCode: 'E0000084',
    description: 'MC HK',
    currency: 'USD',
    region: 'Hong Kong',
    price: 10
  },
  '22400205': {
    productCode: 'E0000083',
    description: 'MC HK',
    currency: 'USD',
    region: 'Hong Kong',
    price: 10
  },

  // UK BINs
  '22360003': {
    productCode: 'E0000040',
    description: 'MC UK',
    currency: 'USD',
    region: 'United Kingdom',
    price: 10
  },
  '23501901': {
    productCode: 'E0000039',
    description: 'MC UK',
    currency: 'USD',
    region: 'United Kingdom',
    price: 10
  },

  // Apple Pay BIN
  '525847': {
    productCode: 'E0W00009',
    description: 'MC HK ApplePay',
    currency: 'USD/EUR',
    region: 'Hong Kong',
    features: ['Apple Pay'],
    price: 15
  },

  // Google Pay BIN
  '525848': {
    productCode: 'E0W00010',
    description: 'MC Global GooglePay',
    currency: 'USD/EUR',
    region: 'Global',
    features: ['Google Pay'],
    price: 15
  },

  // Additional UK BINs (for reference)
  '23800300': {
    productCode: 'E0000037',
    description: 'MC UK',
    currency: 'USD',
    region: 'United Kingdom',
    price: 10
  },
  '24600100': {
    productCode: 'E0000038',
    description: 'MC UK',
    currency: 'USD',
    region: 'United Kingdom',
    price: 10
  },
  '525797': {
    productCode: 'E0000001',
    description: 'MC UK',
    currency: 'USD/EUR',
    region: 'United Kingdom',
    price: 10
  }
};

// Dynamic BIN ranges (can use any BIN starting with these)
export const DYNAMIC_BIN_PRODUCTS = {
  'C0000017': {
    description: 'MC USA (DYNAMIC)',
    currency: 'USD',
    binPrefix: '5',
    supportedBins: ['519075', '52489710', '52489753', '556150', '559292']
  },
  'C0000018': {
    description: 'VISA USA (DYNAMIC)',
    currency: 'USD',
    binPrefix: '4',
    supportedBins: ['42460511', '42883600', '441112000', '44742000', '489683']
  }
};

// Helper function to get product code for a BIN
export function getProductCodeForBIN(bin) {
  // First check exact match
  if (BIN_PRODUCT_MAPPING[bin]) {
    return BIN_PRODUCT_MAPPING[bin];
  }
  
  // If no exact match, check if it's a dynamic BIN
  // For Visa (starts with 4)
  if (bin.startsWith('4')) {
    return {
      productCode: 'C0000018',
      ...DYNAMIC_BIN_PRODUCTS['C0000018']
    };
  }
  
  // For Mastercard (starts with 5)
  if (bin.startsWith('5')) {
    return {
      productCode: 'C0000017',
      ...DYNAMIC_BIN_PRODUCTS['C0000017']
    };
  }
  
  return null;
}

// Get all available BINs grouped by region
export function getBINsByRegion() {
  const regions = {};
  
  Object.entries(BIN_PRODUCT_MAPPING).forEach(([bin, info]) => {
    if (!regions[info.region]) {
      regions[info.region] = [];
    }
    regions[info.region].push({
      bin,
      ...info
    });
  });
  
  return regions;
}

// Get all available currencies
export function getAvailableCurrencies() {
  const currencies = new Set();
  
  Object.values(BIN_PRODUCT_MAPPING).forEach(info => {
    if (info.currency.includes('/')) {
      info.currency.split('/').forEach(curr => currencies.add(curr));
    } else {
      currencies.add(info.currency);
    }
  });
  
  return Array.from(currencies);
}
